// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etf_countries_list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.etf_country_ticker_box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: -webkit-fill-available;
  background-color: var(--bg-card);
  padding: 15px;
  border-radius: 5px;
  border: solid 1px var(--primary);
  
}

.etf_country_ticker_desc{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 30%;
  gap: 10px;
}

.etf_country_ticker_img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.etf_country_ticker_delete_button{
  font-size: 22px;
  font-weight: 700;
  color: var(--primary);
}

.etf_country_weigth_input {
  max-width: 30%;
  border: 1px solid var(--border);
  padding: 10px 15px;
  border-radius: 4px;
  width: 20%;
}

.etf_countries_search_box {
  display: flex;
  flex-direction: row;
  align-self: center;
  width: 50%;
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/actifs/subpages/EtfEdition/EtfEditionTabs/EtfCountriesTab/etfCountriesTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,gCAAgC;;AAElC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB","sourcesContent":[".etf_countries_list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.etf_country_ticker_box{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: -webkit-fill-available;\n  background-color: var(--bg-card);\n  padding: 15px;\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  \n}\n\n.etf_country_ticker_desc{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 30%;\n  gap: 10px;\n}\n\n.etf_country_ticker_img{\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.etf_country_ticker_delete_button{\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.etf_country_weigth_input {\n  max-width: 30%;\n  border: 1px solid var(--border);\n  padding: 10px 15px;\n  border-radius: 4px;\n  width: 20%;\n}\n\n.etf_countries_search_box {\n  display: flex;\n  flex-direction: row;\n  align-self: center;\n  width: 50%;\n  margin-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
